//@flow

import React from 'react'
import { ModalHeader } from '../Modal'
import MediaIconCreator from '../MediaIconCreator'

type props = {
  cropWidth: number,
  cropHeight: number,
  onClose: Function,
  onCancel: Function,
}

const IconCreator = ({ cropWidth, cropHeight, onClose, onCancel }: props) => {
  return (
    <div className="content">
      <ModalHeader title="Create New Icon" close={onClose} />

      <MediaIconCreator
        width={cropWidth}
        height={cropHeight}
        cancel={onCancel}
        ellipsis
      />
    </div>
  )
}

export default IconCreator



// WEBPACK FOOTER //
// ./src/components/Snippets/IconCreator.js